import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <h1>Privacy Policy</h1>
      {/* Privacy Policy content will go here */}
    </div>
  );
};

export default PrivacyPolicy; 